import { render, staticRenderFns } from "./userprotocol2Index.vue?vue&type=template&id=738c25dd&scoped=true&"
import script from "./userprotocol2Index.vue?vue&type=script&lang=js&"
export * from "./userprotocol2Index.vue?vue&type=script&lang=js&"
import style0 from "./userprotocol2Index.vue?vue&type=style&index=0&id=738c25dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c25dd",
  null
  
)

export default component.exports